import React, { useCallback, useEffect, useState } from 'react'

import { useSessionStorage } from 'usehooks-ts'

import { AnimatedSpinner } from '../AnimatedSpinner'
import { AddToViewIcon } from '../Icons'

import { isMacOS } from '../../utils/browserDetect'

interface HaloLinkProps {
  mentorId: string
  autoClick?: boolean
  onLoad?: (isOpened: boolean) => void
  showLink?: boolean
}

const fallbackUrl = 'https://www.napster.ai/apps'
const HALO_WINDOW_OPEN_KEY = 'haloWindowOpen'

const HaloLink: React.FC<HaloLinkProps> = ({ mentorId, showLink, onLoad }) => {
  const [isLoading, setIsLoading] = useState(false)
  const isMac = isMacOS()

  const [haloWindowOpen, setHaloWindowOpen] = useSessionStorage<string | null>(
    HALO_WINDOW_OPEN_KEY,
    null,
  )

  const checkAppAndNavigate = useCallback(
    (e?: React.MouseEvent<HTMLElement>) => {
      if (e) {
        e.preventDefault()
      }
      setIsLoading(true)

      let timeoutId: NodeJS.Timeout | null = null

      const cleanup = (isOpened = true) => {
        if (timeoutId) clearTimeout(timeoutId)
        window.removeEventListener('blur', handleBlur)
        document.removeEventListener('visibilitychange', onVisibility)
        setIsLoading(false)
        if (isOpened) {
          setHaloWindowOpen(mentorId)
        }
        if (onLoad && haloWindowOpen !== mentorId) {
          onLoad(isOpened)
        }
      }

      const handleBlur = () => cleanup()
      const onVisibility = () => {
        console.log('visibilitychange')
        if (document.hidden) {
          handleBlur()
        }
      }

      window.addEventListener('blur', handleBlur)
      document.addEventListener('visibilitychange', onVisibility, {
        passive: true,
      })

      timeoutId = setTimeout(() => {
        cleanup(false)
        if (showLink) {
          window.open(fallbackUrl, '_blank')
        }
      }, 2000)
    },
    [onLoad, showLink],
  )

  useEffect(() => {
    if (!showLink && haloWindowOpen !== mentorId) {
      checkAppAndNavigate()
    }
  }, [showLink, haloWindowOpen, mentorId, checkAppAndNavigate])

  if (!isMac) return null

  return (
    <>
      {isLoading && (
        <iframe
          src={`napster-companion://companion/add/${mentorId}`}
          style={{ display: 'none' }}
        />
      )}
      <a
        href={`napster-companion://companion/add/${mentorId}`}
        className={`z-10 text-white tc-mv-card-favorite-icon ${
          showLink ? '' : 'absolute opacity-0'
        }`}
        id={`add-to-halo-${mentorId}`}
        onClick={checkAppAndNavigate}
      >
        {isLoading ? <AnimatedSpinner /> : <AddToViewIcon size={24} />}
      </a>
    </>
  )
}

export { HaloLink }
